import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Loader from '../Components/Loader';


class LoaderContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { loader } = this.props;
        return (
            <Fragment>
                {loader && loader.isEnabled && loader.isVisible ?
                    <Loader {...loader}/> : null
                }
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        loader: state.loader 
    };

}

export default connect(mapStateToProps)(LoaderContainer);